export default angular.module('eventix.common.directives.dateRange', [])
    /**
     * @ngdoc service
     * @name eventix.common.services.DateRangeHelper
     * @description
     * A helper for date-ranges
     */
    .factory('DateRangeHelper', function(Locales) {
        return {
            /**
             * @ngdoc method
             * @name eventix.common.services.DateRangeHelper#diff
             * @methodOf eventix.common.services.DateRangeHelper
             * @description
             * Calculate difference between start and end in seconds
             *
             * @param {String} start A datetime string
             * @param {String} end A datetime string
             * @param {String} [srcFormat='YYYY-MM-DDT:HH:mm:ssZ'] Optional formatting string that the start and end are currently in
             * @return {Number} Difference in seconds
             */
            diff: function(start, end, srcFormat = 'YYYY-MM-DDTHH:mm:ssZ') {
                let left = moment(start, srcFormat);
                let right = moment(end, srcFormat);
                return right.diff(left, 'seconds');
            },
            /**
             * @ngdoc method
             * @name eventix.common.services.DateRangeHelper#format
             * @methodOf eventix.common.services.DateRangeHelper
             * @description
             * Format a date-range. I.e.: If start-end are less than 12 hours apart,
             * it'll use the least characters. If start and end are both in the current year, it'll
             * use less characters. And if they're both in the current timezone, it'll use less
             * characters.
             *
             * @param {String} start A datetime string
             * @param {String} end A datetime string
             * @param {String} [srcFormat='YYYY-MM-DDT:HH:mm:ssZ'] Optional formatting string that the start and end are currently in
             * @return {String} A formatted string
             */
            format: function(start, end, srcFormat = 'YYYY-MM-DDTHH:mm:ssZ') {
                let now = moment();
                let left = moment(start, srcFormat).locale(Locales.selected);
                let right = moment(end, srcFormat).locale(Locales.selected);
                if(!left.isValid() || !right.isValid())
                    return '';
                let showTwoDates = right.diff(left, 'hours') > 12;
                let showYear = Locales.selected === 'zh_CN' ||
                    now.year() !== left.year() ||
                    left.year() !== right.year();
                let showTimezone = false;
                let hereStart = now.clone().year(left.year()).dayOfYear(left.dayOfYear());
                let hereEnd = now.clone().year(right.year()).dayOfYear(right.dayOfYear());
                if(/ZZ$/.test(srcFormat))
                    showTimezone = hereStart.format('ZZ') !== start.slice(-5) || hereEnd.format('ZZ') !== end.slice(-5);
                else if(/Z$/.test(srcFormat))
                    showTimezone = hereStart.format('Z') !== start.slice(-6) || hereEnd.format('Z') !== end.slice(-6);
                if(showTimezone) {
                    left.utcOffset(start.slice(-6));
                    right.utcOffset(end.slice(-6));
                }

                let timestring = left.format('L');
                if(!showYear)
                    timestring = timestring.slice(0,-5);
                if(!showTimezone)
                    timestring += ' ' + left.format('LT');
                else
                    timestring += ' ' + left.format('HH:mm(Z)');
                timestring += ' –';
                if(showTwoDates)
                    timestring += ' ' + right.format('L');
                if(showTwoDates && !showYear)
                    timestring = timestring.slice(0,-5);
                if(!showTimezone)
                    timestring += ' ' + right.format('LT');
                else
                    timestring += ' ' + right.format('HH:mm(Z)');
                return timestring;
            }
        };
    })
    /**
     * @ngdoc directive
     * @restrict element
     * @name eventix.common.directives:dateRange
     * @description
     * A component to display a date-range. I.e.: If start-end are less than 12 hours apart,
     * it'll use the least characters. If start and end are both in the current year, it'll
     * use less characters. And if they're both in the current timezone, it'll use less
     * characters.
     *
     * @param {String} start An ISO8601 datetime string
     * @param {String} end An ISO8601 datetime string
     */
    .component('dateRange', {
        bindings: {
            start: '@',
            end: '@',
            srcFormat: '@'
        },
        controller: DateRangeController,
        template: '{{ $ctrl.timestring }}'
    }).name;

function DateRangeController(DateRangeHelper, $scope, Locales) {
    const $ctrl = this;

    $ctrl.$postLink = function() {
        $ctrl.srcFormat = $ctrl.srcFormat || 'YYYY-MM-DDTHH:mm:ssZ';
        $scope.$watch(
            '$ctrl.start',
            start => $ctrl.timestring = DateRangeHelper.format(start, $ctrl.end, $ctrl.srcFormat)
        );
        $scope.$watch(
            '$ctrl.end',
            end => $ctrl.timestring = DateRangeHelper.format($ctrl.start, end, $ctrl.srcFormat)
        );
        $scope.$watch(
            () => Locales.selected,
            () => $ctrl.timestring = DateRangeHelper.format($ctrl.start, $ctrl.end, $ctrl.srcFormat)
        );
    };

}
